export enum ApiModules {
  SID = 'SID',
  Organisation = 'Organisation',
  Plan = 'Plan',
  PlanPurchase = 'PlanPurchase',
  Order = 'Order',
  Payment = 'Payment',
  Feature = 'Feature',
  FeatureGroup = 'FeatureGroup',
  CollectionTemplates = 'CollectionTemplates',
  MasterTemplates = 'MasterTemplates',
  Industries = 'Industries',
  Scanner = 'Scanner',
  OrganisationUser = 'OrganisationUser',
  Share = 'Share',
  User = 'User',
  VMS = "VMS",
  Document = 'Document',
  AuthKey = 'AuthKey',
  MasterConfigurations = 'MasterConfigurations',
}
